export default "__VITE_ASSET__4a3459e8__"